import { Close } from "@/components/icons/IconMap";

export const ComplianceConstants = {
  Control: {
    Status: {
      Draft: "draft",
      Active: "active",
      Decommissioned: "decommissioned",
    },
  },
  Compliance: {
    Status: {
      Full: "full",
      Deficient: "deficient",
      Acceptable: "acceptable",
      None: "none",
    },
  },
  Activity: {
    Status: {
      Scheduled: "scheduled",
      Active: "active",
      Overdue: "overdue",
      Resolved: "resolved",
      Closed: "closed",
    },
  },
  Audit: {
    Status: {
      Draft: "draft",
      Scheduled: "scheduled",
      Active: "active",
      Review: "review",
      Closed: "closed",
    },
  },
  Requirement: {
    Status: {
      Draft: "draft",
      Active: "active",
      Decommissioned: "decommissioned",
    },
  },
  StateKeys: {
    ControlRegistries: "control:registries",
    AccessSubscriptions: "control:access-subs",
    AuditRegistries: "audit:registries",
    AuditScope: "audit:scopes",
  },
};
